import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  // ── Root – fixed, covers the app Bar ─────────────────────────────────
  root: {
    position: 'fixed',
    top: 60, 
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1100,
    backgroundColor: '#060e1c',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat, sans-serif',
    color: '#fff',
    overflow: 'hidden',
  },

  // ── Top Nav ───────────────────────────────────────────────────────────
  topNav: {
    backgroundColor: '#071020',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
    height: '44px',
    flexShrink: 0,
  },
  topNavTabs: {
    display: 'flex',
    justifyContent: 'center',
  },
  topNavTab: {
    background: 'none',
    border: 'none',
    borderBottom: '2px solid transparent',
    color: '#6b8aaa',
    fontFamily: 'MontserratSemiBold',
    fontSize: '12px',
    letterSpacing: '1px',
    padding: '0 22px',
    height: '44px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    transition: 'color 0.2s',
    '&:hover': { color: '#cde' },
  },
  topNavTabActive: {
    color: '#06E89F',
    borderBottom: '2px solid #06E89F',
  },

  // ── Layout ────────────────────────────────────────────────────────────
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },

  // ── Sidebar ───────────────────────────────────────────────────────────
  sidebar: {
    backgroundColor: '#071020',
    borderRight: '1px solid #0d2040',
    width: '50px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '12px',
    gap: '4px',
  },
  sidebarBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: 'none',
    background: 'none',
    color: '#6b8aaa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': { backgroundColor: '#0d2040', color: '#fff' },
  },
  sidebarBtnActive: {
    backgroundColor: '#0d2040',
    color: '#06E89F',
  },
  sidebarSpacer: { flex: 1 },
  sidebarBottomBtn: {
    marginBottom: '16px',
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: 'none',
    background: 'none',
    color: '#4a6a8a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': { color: '#fff' },
  },

  // ── Main scrollable area ──────────────────────────────────────────────
  main: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  // ── Section: Sentinel ─────────────────────────────────────────────────
  sentinelSection: {
    padding: '24px 0 0',
  },
  sentinelTitleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '16px',
    gap: '16px',
  },
  sentinelLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1.5px',
    color: '#06E89F',
    textTransform: 'uppercase',
    marginBottom: '4px',
  },
  sentinelTitle: {
    fontFamily: 'MontserratExtraBold',
    fontSize: 'clamp(20px, 3vw, 34px)',
    letterSpacing: '-0.5px',
    textTransform: 'uppercase',
    lineHeight: '1.1',
    margin: 0,
    color: '#ffffff',
  },
  sentinelDateBadge: {
    border: '1px solid #06E89F',
    borderRadius: '4px',
    padding: '6px 14px',
    fontFamily: 'MontserratSemiBold',
    fontSize: '12px',
    color: '#06E89F',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },

  // two-column content row under the sentinel title
  sentinelContent: {
    display: 'flex',
    gap: '20px',
    alignItems: 'stretch',
  },
  sentinelInfoPanel: {
    width: '220px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: '8px',
  },
  infoPanelLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '9px',
    letterSpacing: '1.5px',
    color: '#06E89F',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },
  infoPanelText: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '1.75',
    color: '#8aa8c8',
  },

  // ── Image Comparison ──────────────────────────────────────────────────
  imageCompare: {
    position: 'relative',
    flex: 1,
    height: '320px',
    borderRadius: '6px',
    overflow: 'hidden',
    cursor: 'col-resize',
    userSelect: 'none',
    minWidth: 0,
  },
  imageBase: {
    position: 'absolute',
    inset: 0,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#0d1f10',
  },
  imageOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'transparent',
  },
  sliderLine: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '2px',
    backgroundColor: '#F5A623',
    zIndex: 4,
    pointerEvents: 'none',
  },
  sliderHandle: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#1a3a7a',
    border: '2px solid #4a7aff',
    zIndex: 5,
    cursor: 'col-resize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.6)',
  },
  imageLegend: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    backgroundColor: 'rgba(5, 13, 26, 0.88)',
    borderRadius: '6px',
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    zIndex: 3,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: '#cde',
  },
  legendDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
  },

  // ── Timeline ──────────────────────────────────────────────────────────
  timelineSection: {
    backgroundColor: '#071828',
    padding: '14px 0 0',
    marginTop: '20px',
  },
  timelineHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  timelineLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1px',
    color: '#06E89F',
    textTransform: 'uppercase',
  },
  timelineMode: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1px',
    color: '#4a6a8a',
    textTransform: 'uppercase',
  },
  timelineTrack: {
    position: 'relative',
    height: '4px',
    backgroundColor: '#0d2040',
    borderRadius: '2px',
    marginBottom: '0',
    cursor: 'pointer',
  },
  timelineFill: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    backgroundColor: '#06E89F',
    borderRadius: '2px',
  },
  timelineThumb: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    backgroundColor: '#06E89F',
    border: '2px solid #071828',
    zIndex: 2,
  },
  timelineDates: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0 14px',
  },
  timelineDate: {
    fontFamily: 'Montserrat',
    fontSize: '10px',
    color: '#3a5a7a',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  timelineDateActive: {
    color: '#06E89F',
    fontFamily: 'MontserratSemiBold',
  },

  // ── Status Bar ────────────────────────────────────────────────────────
  statusBar: {
    backgroundColor: '#050d18',
    borderTop: '1px solid #0a1e34',
    borderBottom: '1px solid #0a1e34',
    padding: '6px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  statusDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: '#06E89F',
    flexShrink: 0,
    animation: '$blink 2s ease-in-out infinite',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '0.5px',
    color: '#4a6a8a',
    textTransform: 'uppercase',
  },
  statusGreen: { color: '#06E89F' },
  statusSpacer: { flex: 1 },
  '@keyframes blink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.3 },
  },

  // ── Monthly Analytics ─────────────────────────────────────────────────
  analyticsSection: {
    padding: '32px 0 24px',
  },
  sectionLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1.5px',
    color: '#06E89F',
    textTransform: 'uppercase',
    marginBottom: '4px',
  },
  sectionTitleRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '20px',
    gap: '16px',
  },
  sectionTitle: {
    fontFamily: 'MontserratExtraBold',
    fontSize: 'clamp(22px, 3.5vw, 42px)',
    textTransform: 'uppercase',
    letterSpacing: '-0.5px',
    lineHeight: '1.0',
    margin: 0,
    color: '#ffffff',
  },
  dateRangePicker: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#0a1628',
    border: '1px solid #1a3050',
    borderRadius: '6px',
    padding: '6px 12px',
    cursor: 'pointer',
    flexShrink: 0,
  },
  dateRangeYear: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '11px',
    color: '#fff',
    backgroundColor: '#142840',
    borderRadius: '3px',
    padding: '2px 6px',
  },
  dateRangeCustom: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '11px',
    color: '#6b8aaa',
  },

  chartModeBadge: {
    fontFamily: 'Montserrat',
    fontSize: '11px',
    color: '#6b8aaa',
    marginBottom: '12px',
    padding: '6px 10px',
    backgroundColor: '#0a1628',
    border: '1px solid #1a3050',
    borderRadius: '4px',
    display: 'inline-block',
  },

  annualSummaryTable: {
    borderTop: '1px solid #1a3050',
    padding: '12px 16px 16px',
  },
  annualSummaryHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: '8px',
    fontFamily: 'MontserratSemiBold',
    fontSize: '9px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: '#06E89F',
    marginBottom: '8px',
    paddingBottom: '6px',
    borderBottom: '1px solid #1a3050',
  },
  annualSummaryRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: '8px',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    color: '#8aa8c8',
    padding: '6px 0',
    borderBottom: '1px solid #0d2040',
    '&:last-child': {
      borderBottom: 'none',
    },
    '& span:first-child': {
      color: '#ffffff',
      fontFamily: 'MontserratSemiBold',
    },
  },

  // chart + side panel layout
  chartRow: {
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',
  },
  chartBox: {
    flex: 1,
    minWidth: 0,
    backgroundColor: '#071020',
    borderRadius: '6px',
    overflow: 'hidden',
  },
  metricsPanel: {
    width: '200px',
    flexShrink: 0,
    paddingTop: '16px',
  },
  metricsPanelLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '9px',
    letterSpacing: '1.5px',
    color: '#F5A623',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },
  metricsPanelText: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '1.75',
    color: '#8aa8c8',
  },

  // ── Accumulated Deforestation ─────────────────────────────────────────
  accumulatedSection: {
    padding: '0 0 40px',
  },
  accumulatedRow: {
    display: 'flex',
    gap: '20px',
    alignItems: 'flex-start',
    marginTop: '20px',
  },
  accumulatedInfoPanel: {
    width: '220px',
    flexShrink: 0,
    paddingTop: '8px',
  },
  accumulatedChart: {
    flex: 1,
    minWidth: 0,
    backgroundColor: '#071020',
    borderRadius: '6px',
    overflow: 'hidden',
  },
  statsCard: {
    width: '210px',
    flexShrink: 0,
    backgroundColor: '#0a1628',
    border: '1px solid #1a3050',
    borderRadius: '8px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  statsIcon: {
    color: '#06E89F',
    fontSize: '18px',
    marginBottom: '4px',
  },
  statsLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '9px',
    letterSpacing: '1px',
    color: '#6b8aaa',
    textTransform: 'uppercase',
    marginBottom: '4px',
  },
  statsValue: {
    fontFamily: 'MontserratExtraBold',
    fontSize: '44px',
    letterSpacing: '-1.5px',
    lineHeight: '1',
    color: '#fff',
  },
  statsUnit: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    color: '#6b8aaa',
    marginTop: '2px',
  },
  statsDelta: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '11px',
    color: '#e53935',
    marginTop: '6px',
  },
  statsDivider: {
    borderTop: '1px solid #1a3050',
    paddingTop: '14px',
  },
  exportLabel: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '9px',
    letterSpacing: '1px',
    color: '#6b8aaa',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },
  exportRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  exportFormat: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '13px',
    color: '#fff',
  },
  exportFormatSub: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    color: '#6b8aaa',
  },
  downloadBtn: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    backgroundColor: '#0d2040',
    border: '1px solid #1a3050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#06E89F',
    '&:hover': { backgroundColor: '#1a3050' },
  },

  // ── Empty tab content ─────────────────────────────────────────────────
  emptyTab: {
    padding: '48px 0',
  },
  emptyTabText: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    color: '#4a6a8a',
    lineHeight: '1.7',
    maxWidth: '600px',
    marginTop: '16px',
  },
}));

export default useStyles;
